<template>
	<v-toolbar class="vopsHeader" :color="color" :flat="flat" v-bind="$attrs">
		<v-toolbar-title role="heading" aria-level="1">
			<slot name="label">
				{{label}}
				<slot name="sublabel">
					<div class="subtitle-2" role="heading" aria-level="2" v-if="sublabel">{{sublabel}}</div>
				</slot>
			</slot>
		</v-toolbar-title>
		<v-spacer />
		<slot></slot>
	</v-toolbar>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Header extends Vue {
	@Prop({ type: Boolean, default: true }) flat: boolean;
	@Prop({ type: String, default: "transparent" }) color: string;
	@Prop() label: string;
	@Prop({ type: String }) sublabel: string;
}
</script>